<template>
    <div id="pathways-manage-pathways">
        
        <div class="row">
            <transition-group tag="div" name="fade-slow">
                <div v-for="(conn, conn_index) in local_connection_datasets" class="mb-2 position-relative" :id="'conn_' + conn.id" :key="conn.id" ref="managePathways">
                    <div class="accordion accordion-flush">
                        <div class="accordion-item">
                            <div class="accordion-header px-3 py-2">
                                <button class="accordion-button collapsed p-0" type="button"
                                    :data-bs-target="'#manage-pathway-' + conn.id" data-bs-toggle="collapse"
                                    aria-expanded="false" :aria-controls="'manage-pathway-' + conn.id">
                                    <div class="d-flex align-items-center">
                                        <img :src="conn.integration.logo_url" :alt="conn.integration.name" class="avatar rounded-circle avatar-sm me-2 bg-white">
                                        <div class="d-flex flex-column">
                                            <div class="d-flex align-items-center">
                                                <h3 class="d-inline-block m-0">{{(isFile(conn) ? 'File Export' : conn.name)}}</h3>
                                                <div class="badge ms-2" :class="{
                                                    'bg-green bg-icon-success': !hasSyncErrors(conn),
                                                    'bg-red bg-icon-danger': hasSyncErrors(conn)
                                                }">{{ hasSyncErrors(conn) ? 'Error' : 'Active' }}</div>
                                            </div>
                                            <p class="m-0">
                                                {{conn.pushed_segment_count}} {{conn.pushed_segment_count != 1 ? "Audiences" : "Audience" }}
                                                {{ isFile(conn) ? "Customized" : "Pushed" }}
                                            </p>
                                        </div>
                                    </div>
                                </button>
                            </div>

                            <div :id="'manage-pathway-' + conn.id" class="collapse accordion-collapse p-3 pt-0">
                                <hr class="m-0">
                                <div class="card my-3 table-card" v-for="(set, set_index) in conn.datasets_to_sync">
                                    <div class="card-header">
                                        <div class="row">
                                            <div class="col-lg-6 col-12">
                                                <h3 class="mt-2">{{ propercase(set.name) }}</h3>
                                            </div>
                                            <div class="col-lg-6" v-if="canEdit('pathways')">
                                                <div class="d-flex justify-content-end justify-self-end gap-2" v-if="(conn.census_destination_id != null || isFile(conn))">
                                                    <Link class="btn btn-secondary" :href="'/pathways/' + client.url + '/' + conn.id + '/mapping/' + set.data_source + '/' + set.id" data-bs-toggle="tooltip" title="Configure how your data fields map to the destination system">
                                                        <img class="icon pe-0" src="/img/icons/avid-icons/map.svg" alt="">
                                                    </Link>

                                                    <Link class="btn btn-secondary" :href="'/pathways/' + client.url + '/' + conn.id + '/filter/' + set.data_source + '/' + set.id" data-bs-toggle="tooltip" title="Set up filters to control which records are allowed to be synced to the destination by default">
                                                        <img class="icon pe-0" src="/img/icons/avid-icons/filter-funnel-01.svg" alt="">
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="card-body table-width-responsive p-0">
                                        <table class="table table-without-pagination mb-0">
                                            <thead>
                                                <tr class="table-header-row">
                                                    <th @click="sortByKey('name', conn_index, set_index)" class="d-table-cell">
                                                        <div class="d-flex flex-row">
                                                            Audience
                                                            <div class="d-flex flex-column">
                                                                <img class="sort-key" src="/img/icons/avid-icons/chevron-up.svg" :class="(sort_conn_index == conn_index && sort_set_index == set_index && sort_key=='name' && sort_order=='asc')? 'sort-key-active' :''" alt="">
                                                                <img class="sort-key" src="/img/icons/avid-icons/chevron-down.svg" :class="(sort_conn_index == conn_index && sort_set_index == set_index && sort_key=='name' && sort_order=='des')? 'sort-key-active' :''" alt="">
                                                            </div>
                                                        </div>
                                                    </th>
                                                    <th @click="sortByKey('type', conn_index, set_index)" class="d-none d-md-table-cell" v-if="showSegmentTypeColumn(conn_index, set_index)">
                                                        <div class="d-flex flex-row">
                                                            Type
                                                            <div class="d-flex flex-column">
                                                                <img class="sort-key" src="/img/icons/avid-icons/chevron-up.svg" :class="(sort_conn_index == conn_index && sort_set_index == set_index && sort_key=='type' && sort_order=='asc')? 'sort-key-active' :''" alt="">
                                                                <img class="sort-key" src="/img/icons/avid-icons/chevron-down.svg" :class="(sort_conn_index == conn_index && sort_set_index == set_index && sort_key=='type' && sort_order=='des')? 'sort-key-active' :''" alt="">
                                                            </div>
                                                        </div>
                                                    </th>
                                                    <th @click="sortByKey('sizes', conn_index, set_index)" class="d-none d-sm-table-cell">
                                                        <div class="d-flex flex-row">
                                                            Estimated Records 
                                                            <img class="info-icon" src="/img/icons/avid-icons/info.svg" data-bs-toggle="tooltip" title="This estimate will vary, even for the same audience, based upon the destination and what it considers the 'primary key'." alt=""></img>
                                                            <div class="d-flex flex-column">
                                                                <img class="sort-key" src="/img/icons/avid-icons/chevron-up.svg" :class="(sort_conn_index == conn_index && sort_set_index == set_index && sort_key=='sizes' && sort_order=='asc')? 'sort-key-active' :''" alt="">
                                                                <img class="sort-key" src="/img/icons/avid-icons/chevron-down.svg" :class="(sort_conn_index == conn_index && sort_set_index == set_index && sort_key=='sizes' && sort_order=='des')? 'sort-key-active' :''" alt="">
                                                            </div>

                                                        </div>
                                                    </th>
                                                    <th @click="sortByKey('sync_active', conn_index, set_index)" class="d-none d-sm-table-cell">
                                                        <div class="d-flex flex-row">
                                                            {{ isFile(conn) ? 'Custom Export Columns' : 'Sync Status' }}
                                                            <div class="d-flex flex-column">
                                                                <img class="sort-key" src="/img/icons/avid-icons/chevron-up.svg" :class="(sort_conn_index == conn_index && sort_set_index == set_index && sort_key=='sync_active' && sort_order=='asc')? 'sort-key-active' :''" alt="">
                                                                <img class="sort-key" src="/img/icons/avid-icons/chevron-down.svg" :class="(sort_conn_index == conn_index && sort_set_index == set_index && sort_key=='sync_active' && sort_order=='des')? 'sort-key-active' :''" alt="">
                                                            </div>
                                                        </div>
                                                    </th>

                                                    <th @click="sortByKey('failed_records', conn_index, set_index)" class="table-column-2 d-none d-xl-table-cell" v-if="!isFile(conn)">
                                                        <div class="d-flex flex-row">
                                                            Last Sync Failures <img class="info-icon" src="/img/icons/avid-icons/info.svg" data-bs-toggle="tooltip" title="If a record isn't properly formatted, the destination may reject it. You can download the failed records to see what went wrong." alt=""></img>
                                                            <div class="d-flex flex-column">
                                                                <img class="sort-key" src="/img/icons/avid-icons/chevron-up.svg" :class="(sort_conn_index == conn_index && sort_set_index == set_index && sort_key=='sync_active' && sort_order=='asc')? 'sort-key-active' :''" alt="">
                                                                <img class="sort-key" src="/img/icons/avid-icons/chevron-down.svg" :class="(sort_conn_index == conn_index && sort_set_index == set_index && sort_key=='sync_active' && sort_order=='des')? 'sort-key-active' :''" alt="">
                                                            </div>
                                                        </div>
                                                    </th>
                                                    <th @click="sortByKey('updated_records', conn_index, set_index)" class="table-column-2 d-none d-xl-table-cell" v-if="!isFile(conn)">
                                                        <div class="d-flex flex-row">
                                                            Last Sync Successes <img class="info-icon" src="/img/icons/avid-icons/info.svg" data-bs-toggle="tooltip" title="Avid will only sync records that have changed since the last sync. This is a count of records that have been synced successfully." alt=""></img>
                                                            <div class="d-flex flex-column">
                                                                <img class="sort-key" src="/img/icons/avid-icons/chevron-up.svg" :class="(sort_conn_index == conn_index && sort_set_index == set_index && sort_key=='sync_active' && sort_order=='asc')? 'sort-key-active' :''" alt="">
                                                                <img class="sort-key" src="/img/icons/avid-icons/chevron-down.svg" :class="(sort_conn_index == conn_index && sort_set_index == set_index && sort_key=='sync_active' && sort_order=='des')? 'sort-key-active' :''" alt="">
                                                            </div>
                                                        </div>
                                                    </th>
                                                    <th @click="sortByKey('last_synced', conn_index, set_index)" class="table-column-2 d-none d-md-table-cell"  v-if="!isFile(conn)">
                                                        <div class="d-flex flex-row">
                                                            Last Synced
                                                            <div class="d-flex flex-column">
                                                                <img class="sort-key" src="/img/icons/avid-icons/chevron-up.svg" :class="(sort_conn_index == conn_index && sort_set_index == set_index && sort_key=='last_synced' && sort_order=='asc')? 'sort-key-active' :''" alt="">
                                                                <img class="sort-key" src="/img/icons/avid-icons/chevron-down.svg" :class="(sort_conn_index == conn_index && sort_set_index == set_index && sort_key=='last_synced' && sort_order=='des')? 'sort-key-active' :''" alt="">
                                                            </div>
                                                        </div>
                                                    </th>
                                                    <th class="d-table-cell column-sort-disabled pe-3" width="1" v-if="canEdit('pathways')">
                                                        Action
                                                    </th>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                <tr v-for="(segment, seg_index) in getFilteredSegments(set.segments, conn)" :key="segment.id" :id="'conn-'+conn.id+'-segment-row-' + segment.id">
                                                    <td class="d-table-cell" >
                                                        <a class="text-wrap" :href="'/audience/' + client.url +'/' + segment.id" v-if="canEdit('pathways')">
                                                            {{ segment.name }}
                                                        </a>
                                                        <span class="text-wrap" v-else>
                                                            {{ segment.name }}
                                                        </span>
                                                    </td>
                                                    <td class="d-none d-md-table-cell" v-if="showSegmentTypeColumn(conn_index, set_index)">
                                                        <span class="badge badge-secondary">{{ propercase(segment.type || 'Owned') }}</span>
                                                    </td>
                                                    <td class="d-none d-sm-table-cell">
                                                        <span v-if="segment.type === 'modeled'">--</span>
                                                        <span v-else-if="window_width < 577">
                                                            {{ num_abbr(getSize(segment, conn.id)) }}
                                                        </span>
                                                        <span v-else>
                                                            {{ number_with_zero(getSize(segment, conn.id)) }}
                                                        </span>
                                                    </td>
                                                    <td class="d-none d-sm-table-cell" v-if="!isFile(conn)">
                                                        <span class="badge bg-gray bg-icon-progress" v-if="segment.sync_active ==1 && sync_busy[conn.id + '_' + segment.id]">Syncing</span>
                                                        <span class="badge bg-red bg-icon-danger" 
                                                                v-else-if="segment.sync_active ==1 && getLastSyncStatus(conn.id, segment.id) == 'failed'"
                                                                data-bs-toggle="popover"
                                                                :data-bs-content="getLastSyncErrorMessage(conn.id, segment.id)"
                                                                data-bs-trigger="manual"
                                                                data-bs-container="body"
                                                                data-bs-placement="auto"
                                                                data-bs-html="true">Error</span>
                                                        <span class="badge bg-green bg-icon-success" v-else-if="segment.sync_active ==1">Active</span>
                                                        <span class="badge badge-secondary" v-else>Inactive</span>
                                                    </td>
                                                    <td class="d-none d-sm-table-cell" v-else>
                                                        <span class="badge bg-green bg-icon-success" v-if="segment.sync_active ==1">True</span>
                                                        <span class="badge badge-secondary" v-else>False</span>
                                                    </td>
                                                    <td class="table-column-2 d-none d-xl-table-cell" v-if="!isFile(conn)">
                                                        <span v-if="segment.sync_active == 0"></span>
                                                        <span v-else-if="getLastSyncStatus(conn.id, segment.id) == 'failed'">N/A</span>
                                                        <span v-else-if="getLastSyncRecordsFailed(conn.id, segment.id) == 0">0</span>
                                                        <span v-else-if="isLastSyncedOverTwoWeeks(segment.last_synced) || !canExport('pathways') || segment.type === 'modeled'" data-bs-toggle="tooltip" :title="segment.type === 'modeled' ? 'Download not available for modeled segments' : 'These records are only retained for 7 days after the sync has finished. They cannot be downloaded anymore.'">
                                                            {{ number(getLastSyncRecordsFailed(conn.id, segment.id)) }}
                                                        </span>
                                                        <a v-else href="#" @click.prevent="downloadRecords(conn.id, segment.id, 'rejected')" :disabled="failed_records_busy[conn.id + '_' + segment.id]">
                                                            <span v-if="!failed_records_busy[conn.id + '_' + segment.id]">
                                                                {{ number(getLastSyncRecordsFailed(conn.id, segment.id)) }}
                                                            </span>
                                                            <span v-else>
                                                                <div class="d-inline-block spinner-border spinner-border-sm" role="status"></div>
                                                            </span>
                                                        </a>
                                                    </td>
                                                    <td class="table-column-2 d-none d-xl-table-cell" v-if="!isFile(conn)">
                                                        <span v-if="segment.sync_active == 0"></span>
                                                        <span v-else-if="getLastSyncStatus(conn.id, segment.id) == 'failed'">N/A</span>
                                                        <span v-else-if="getLastSyncRecordsUpdated(conn.id, segment.id) == 0">0</span>
                                                        <span v-else-if="isLastSyncedOverTwoWeeks(segment.last_synced) || !canExport('pathways') || segment.type === 'modeled'" data-bs-toggle="tooltip" :title="segment.type === 'modeled' ? 'Download not available for modeled segments' : 'These records are only retained for 7 days after the sync has finished. They cannot be downloaded anymore.'">
                                                            {{ number(getLastSyncRecordsUpdated(conn.id, segment.id)) }}
                                                        </span>
                                                        <a v-else href="#" @click.prevent="downloadRecords(conn.id, segment.id, 'succeeded')" :disabled="updated_records_busy[conn.id + '_' + segment.id]">
                                                            <span v-if="!updated_records_busy[conn.id + '_' + segment.id]">
                                                                {{ number(getLastSyncRecordsUpdated(conn.id, segment.id)) }}
                                                            </span>
                                                            <span v-else>
                                                                <div class="d-inline-block spinner-border spinner-border-sm" role="status"></div>
                                                            </span>
                                                        </a>
                                                    </td>
                                                    <td class="table-column-2 d-none d-md-table-cell" v-if="!isFile(conn)">
                                                        <span :title="datetime(segment.last_synced)" data-bs-toggle="tooltip">
                                                            {{ date(segment.last_synced) }}
                                                        </span>
                                                    </td>

                                                    <td class="d-table-cell">
                                                        <div class="dropdown d-flex justify-content-center">
                                                            <button class="btn btn-white btn-icon-only-md" v-if="canExport('pathways')" data-bs-toggle="dropdown" data-bs-auto-close="true" aria-expanded="false">
                                                                <img class="icon" src="/img/icons/avid-icons/dots-vertical.svg" data-bs-toggle="tooltip" title="Actions" alt="">
                                                            </button>
                                                            <div class="dropdown-menu dropdown-menu-primary dropdown-menu-end">
                                                                <a class="dropdown-item" href="#"
                                                                    @click.prevent="exportSegment(conn.id, segment)"
                                                                    :class="{ 'disabled': export_busy[conn.id + '_' + segment.id] != null && export_busy[conn.id + '_' + segment.id] == true }"
                                                                    v-if="hasMatchingCensusConnection(conn.id) && segment.type !== 'modeled' && segment.sync_active != 0">
                                                                    <span v-if="export_busy[conn.id + '_' + segment.id] == null || export_busy[conn.id + '_' + segment.id] == false">
                                                                        <img class="icon me-2" src="/img/icons/avid-icons/file-download.svg" alt=""> Export Audience
                                                                    </span>
                                                                    <span v-else>
                                                                        <div class="d-inline-block spinner-border spinner-border-sm me-2" role="status"></div> Exporting...
                                                                    </span>
                                                                </a>

                                                                <a class="dropdown-item" :href="'/pathways/' + client.url + '/' + conn.id + '/mapping/' + set.data_source + '/' + set.id + '/' + segment.id" v-if="segment.sync_active != 0 && segment.type !== 'modeled'">
                                                                    <img class="icon me-2" src="/img/icons/avid-icons/map.svg" alt=""> {{ isFile(conn) ? 'Change Export Columns' : 'Map Audience to Destination' }}
                                                                </a>
                                                                

                                                                <a class="dropdown-item" href="#"
                                                                    @click.prevent="cancelSync(conn, segment)"
                                                                    :class="{ 'disabled': !sync_busy[conn.id + '_' + segment.id] }"
                                                                    v-if="!isFile(conn) && sync_busy[conn.id + '_' + segment.id] != null && sync_busy[conn.id + '_' + segment.id] == true ">
                                                                    <span>
                                                                        <img class="icon me-2" src="/img/icons/avid-icons/forbidden.svg" alt="">
                                                                        Cancel Sync
                                                                    </span>
                                                                </a>

                                                                <a class="dropdown-item" href="#"
                                                                    @click.prevent="toggleSyncSegment(conn, segment)"
                                                                    v-else-if="!isFile(conn)">
                                                                    <span>
                                                                        <img class="icon me-2" v-if="segment.sync_active == 0" src="/img/icons/avid-icons/sync.svg" alt="">
                                                                        <img class="icon me-2" v-else src="/img/icons/avid-icons/forbidden.svg" alt="">
                                                                        {{ segment.sync_active == 0 ? 'Activate Sync' : 'Deactivate Sync' }}
                                                                    </span>
                                                                </a>

                                                                <a class="dropdown-item" href="#"
                                                                    @click.prevent="forceSync(conn, segment)"
                                                                    :class="{ 'disabled': sync_busy[conn.id + '_' + segment.id] != null && sync_busy[conn.id + '_' + segment.id] == true }"
                                                                    v-if="!isFile(conn) && segment.sync_active == 1">
                                                                    <span >
                                                                        <img class="icon me-2" src="/img/icons/avid-icons/sync.svg" alt="">
                                                                        Force Sync
                                                                    </span>
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </transition-group>
        </div>
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import Swal from 'sweetalert2';
import { Link, router } from '@inertiajs/vue3';
import permissionsMixin from '../../mixins/permissions';
import { useNotifications } from '../../composables/useNotifications';

export default defineComponent({
    name: 'PathwaysManagePathways',
    components: {
        Swal,
        Link
    },
    mixins: [permissionsMixin],
    setup() {
        const { showNotification } = useNotifications();
        return {
            showNotification,
            router
        };
    },
    props: {
        connection_datasets: {
            type: Array,
            required: true
        },
        client: {
            type: Object,
            required: true
        },
        segments: {
            type: Array,
            required: true
        },
        datasets: {
            type: Array,
            required: true
        },
        datablends: {
            type: Array,
            required: true
        },
        census_connections: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            local_datasets: [],
            local_datablends: [],
            local_census_connections: [],
            local_connection_datasets:[],
            segment: {
                name: '',
                data_source_id: null,
                filter: null
            },
            sort_conn_index: null,
            sort_set_index: null,
            sort_key: null,
            sort_order: 'asc',
            export_busy:{},
            sync_busy: {},
            failed_records_busy: {},
            updated_records_busy: {},

            window_width: window.innerWidth,
        };
    },
    beforeMount() {
        this.local_datasets = this.datasets;
        this.local_datablends = this.datablends;
        this.local_census_connections = this.census_connections;
        this.local_connection_datasets = this.connection_datasets;

        //Set the sync busy status for each segment. Loop through the local_census_connections and their syncs.
        for(var i = 0; i < this.local_census_connections.length; i++) {
            if(this.local_census_connections[i].syncs != null){
                for(var j = 0; j < this.local_census_connections[i].syncs.length; j++) {
                    let sync = this.local_census_connections[i].syncs[j];
                    const busyStatuses = ['queued', 'pending', 'running', 'working'];
                    this.sync_busy[this.local_census_connections[i].connection_id + '_' + sync.segment_id] = 
                    busyStatuses.includes(sync.last_sync_status);
                }
            }
        }
    },
    mounted() {
        const params = new URLSearchParams(window.location.search);
        if(params.get('conn') != null){
            var pathwayDiv = document.querySelector('#manage-pathway-'+params.get('conn'));
            pathwayDiv.classList.add('show');

            var accordionToggleBtn = document.querySelector('[data-bs-target="#manage-pathway-' + params.get('conn') + '"]');
            accordionToggleBtn.classList.remove('collapsed');
        }
        //Highlight the segment row
        if(params.get('conn') != null && params.get('seg') != null){
            var seg_row = document.querySelector('#conn-'+params.get('conn')+'-segment-row-'+params.get('seg'));
            seg_row.classList.add('segment-row-highlight');
            //Scoll down to the row
            seg_row.scrollIntoView({ behavior: 'smooth' });
        }

        // Initialize tooltips
        const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
        const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new window.bootstrap.Tooltip(tooltipTriggerEl));

        // Initialize popovers
        const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]');
        const popoverList = [...popoverTriggerList].map(popoverTriggerEl => {
            const popover = new window.bootstrap.Popover(popoverTriggerEl, {
                html: true,
                trigger: 'manual'
            });

            let timeout;
            
            popoverTriggerEl.addEventListener('mouseenter', () => {
                clearTimeout(timeout);
                popover.show();
            });

            popoverTriggerEl.addEventListener('mouseleave', () => {
                timeout = setTimeout(() => {
                    const popoverElement = document.querySelector('.popover');
                    if (!popoverElement || !popoverElement.matches(':hover')) {
                        popover.hide();
                    }
                }, 100);
            });

            // Add event listeners to the popover element itself
            document.addEventListener('mouseover', (e) => {
                if (e.target.closest('.popover')) {
                    clearTimeout(timeout);
                }
            });

            document.addEventListener('mouseout', (e) => {
                if (e.target.closest('.popover')) {
                    timeout = setTimeout(() => {
                        const popoverElement = document.querySelector('.popover');
                        if (!popoverElement || !popoverElement.matches(':hover')) {
                            popover.hide();
                        }
                    }, 100);
                }
            });

            return popover;
        });
    },
    beforeUnmount() {
        // Clean up tooltips and popovers
        const tooltipList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
        tooltipList.forEach(tooltip => {
            const tooltipInstance = window.bootstrap.Tooltip.getInstance(tooltip);
            if (tooltipInstance) {
                tooltipInstance.dispose();
            }
        });

        const popoverList = document.querySelectorAll('[data-bs-toggle="popover"]');
        popoverList.forEach(popover => {
            const popoverInstance = window.bootstrap.Popover.getInstance(popover);
            if (popoverInstance) {
                popoverInstance.dispose();
            }
        });
    },
    methods: {
        getLastSync(conn_id, segment_id) {
            //Get the last sync job for this segment
            for(var i = 0; i < this.local_census_connections.length; i++) {
                if(this.local_census_connections[i].connection_id == conn_id) {
                    //Get the last sync job for this segment
                    for(var j = 0; j < this.local_census_connections[i].syncs.length; j++) {
                        if(this.local_census_connections[i].syncs[j].segment_id == segment_id) {
                            return this.local_census_connections[i].syncs[j];
                        }
                    }
                }
            }
            return null;
        },
        getLastSyncRunId(conn_id, segment_id) {
            var last_sync = this.getLastSync(conn_id, segment_id);
            if(last_sync != null)
                return last_sync.last_sync_run_id;
            return null;
        },
        getLastSyncStatus(conn_id, segment_id) {
            var last_sync = this.getLastSync(conn_id, segment_id);
            if(last_sync != null)
                return last_sync.last_sync_status;
            return null;
        },
        getLastSyncRecordsFailed(conn_id, segment_id) {
            var last_sync = this.getLastSync(conn_id, segment_id);
            if(last_sync != null){
                return last_sync.last_sync_records_failed;
            }
            return null;
        },
        getLastSyncRecordsUpdated(conn_id, segment_id) {
            var last_sync = this.getLastSync(conn_id, segment_id);
            if(last_sync != null)
                return last_sync.last_sync_records_updated;
            return null;
        },
        getLastSyncErrorMessage(conn_id, segment_id) {
            var last_sync = this.getLastSync(conn_id, segment_id);
            if(last_sync != null)
                return last_sync.last_sync_error_message;
            return null;
        },
        
        isFile(conn) {
            return conn.integration_id == '71b0c3b0-8390-49ec-9984-1c04b7384d38';
        },
        getSize(segment, conn_id) {
            //If it hasn't been sent, just show 0
            if(!segment.sizes)
                return null;

            let sizes = segment.sizes;
            let census_conn_id = 0;
            //Find the census connection that matches connection and data source info
            for(var i = 0; i < this.local_census_connections.length; i++)
                if(this.local_census_connections[i].connection_id == conn_id && segment.data_source_id == this.local_census_connections[i].data_source_id &&
                    this.local_census_connections[i].source == segment.source)
                    census_conn_id = this.local_census_connections[i].id;

            //Get one that is specific to this census connection
            for (var i = 0; i < sizes.length; i++){
                if (sizes[i].id == census_conn_id)
                    return sizes[i].size;
            }

            //Get one that is specific to this census connection
            for (var i = 0; i < sizes.length; i++){
                if (sizes[i].id == 0)
                    return sizes[i].size;
            }

            return null
        },
        exportSegment(conn_id, segment) {
            //See if there is a census_connection set up
            for(var i = 0; i < this.local_census_connections.length; i++) {
                if(this.local_census_connections[i].connection_id == conn_id && segment.source ==
                    this.local_census_connections[i].source && segment.data_source_id ==
                    this.local_census_connections[i].data_source_id) {

                    var form_data = {
                        segment_id: segment.id,
                        census_connection: this.local_census_connections[i]
                    }

                    this.export_busy[conn_id + '_' + segment.id] = true;
                    this.$forceUpdate();

                    //Call the webhook to save the new sync
                    window.axios.post('/api/census/export', form_data)
                        .then(response => {
                            //Make a link and then "click" on it
                            var link = document.createElement("a");
                            link.href = response.data.url;
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                            this.export_busy[conn_id + '_' + segment.id] = false;
                            this.$forceUpdate();
                        })
                        .catch(error => {
                            if(error.response.status == 400){
                                //Fields weren't mapped, time to redirect....
                                this.export_busy[conn_id + '_' + segment.id] = false;
                                router.visit('/pathways/' + this.client.url + '/' + segment.id + '/' + conn_id);
                            }

                        });
                    return;
                }
            }

            //If they get this far, the fields weren't mapped. Send to the mapping page that will also export
            router.visit('/pathways/' + this.client.url + '/' + segment.id + '/' + conn_id);
        },
        editSegment(seg) {
            this.segment = seg;
        },
        hasActiveModeledSegments(segment, conn_id) {
            // Check if this segment has active modeled segments depending on it
            if (segment.type !== 'owned') {
                return false;
            }
            
            // Look for modeled segments that depend on this segment
            for (var i = 0; i < this.segments.length; i++) {
                var seg = this.segments[i];
                if (seg.type === 'modeled' && seg.data_source_id === segment.id) {
                    // Check if this modeled segment has an active sync
                    for (var j = 0; j < this.local_census_connections.length; j++) {
                        var census_conn = this.local_census_connections[j];
                        if (census_conn.connection_id === conn_id && seg.data_source.data_source_id &&
                            seg.data_source.data_source_id === census_conn.data_source_id) {
                            // Check if there's an active sync for this modeled segment
                            for(var k = 0; k < seg.pushed_pathways.length; k++) {
                                if(seg.pushed_pathways[k].conn_id == conn_id) {
                                    return true;
                                }
                            }
                        }
                    }
                }
            }
            return false;
        },
        getModeledSegmentNames(segment, conn_id) {
            // Get names of modeled segments that depend on this segment
            var modeledNames = [];
            for (var i = 0; i < this.segments.length; i++) {
                var seg = this.segments[i];
                if (seg.type === 'modeled' && seg.data_source_id === segment.id) {
                    // Check if this modeled segment has an active sync
                    for (var j = 0; j < this.local_census_connections.length; j++) {
                        var census_conn = this.local_census_connections[j];
                        if (census_conn.connection_id === conn_id && seg.data_source.data_source_id &&
                            seg.data_source.data_source_id === census_conn.data_source_id) {
                            // Check if there's an active sync for this modeled segment
                            for(var k = 0; k < seg.pushed_pathways.length; k++) {
                                if(seg.pushed_pathways[k].conn_id == conn_id) {
                                    modeledNames.push(seg.name);
                                }
                            }
                        }
                    }
                }
            }
            return modeledNames;
        },
        toggleSyncSegment(conn, segment) {
            var conn_id = conn.id;

            // Check if we're disabling a base segment with active modeled segments
            if (segment.sync_active == 1 && this.hasActiveModeledSegments(segment, conn_id)) {
                var modeledNames = this.getModeledSegmentNames(segment, conn_id);
                var self = this;
                
                Swal.fire({
                    title: "Associated Modeled Audiences Will Also Be Disabled",
                    html: `<p>This audience has active audiences that depend on it:</p>
                           <p><strong>${modeledNames.join('</strong>, <strong>')}</strong></p>
                           <p>Disabling this audience will also disable all modeled audiences based on it. Are you sure you want to continue?</p>`,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: "Yes, Disable All",
                    cancelButtonText: "Cancel",
                    customClass: {
                        popup: 'swal-warning'
                    },
                }).then((result) => {
                    if (result.isConfirmed) {
                        self.performToggleSync(conn, segment);
                    }
                });
                return;
            }

            this.performToggleSync(conn, segment);
        },
        performToggleSync(conn, segment) {
            var conn_id = conn.id;

            if(conn.census_destination_id == null){
                const isAvidIntegration = conn.integration.census_connection_type === 'avid';
                // Avid integrations bypass Census OAuth; for others, show popup if OAuth required
                if(!isAvidIntegration && conn.integration.census_requires_oauth){
                    // census oauth
                    var self = this;
                    Swal.fire({
                        title: "Additional Access is Needed",
                        text: "Avid has partnered with a software service named Census to activate the ability to push data to "+conn.integration.display_name+". This destination requires additional authentication before it can be used.",
                        iconHtml: '<i class="fas fa-exclamation"></i>',
                        showCancelButton: true,
                        confirmButtonText: "Proceed",
                        customClass: {
                            popup: 'swal-warning'
                        },
                        }).then((result) => {
                            if (result.isConfirmed) {
                                window.location = '/integrations/'+this.client.url+'/census/oauth/' + conn.id + '/'+ segment.id;
                            }
                        });
                }
                else {
                    //Otherwise, jump to the mapping page
                    window.location = '/pathways/' + this.client.url + '/' +segment.id + '/' + conn.id;
                }
                return;
            }

            //See if there is a census_connection set up
            for(var i = 0; i < this.local_census_connections.length; i++) {
                if(this.local_census_connections[i].connection_id == conn_id && segment.source ==
                    this.local_census_connections[i].source && segment.data_source_id ==
                    this.local_census_connections[i].data_source_id) {

                    var form_data = {
                        client_id: this.client.id,
                        segment_id: segment.id,
                        census_connection_id: this.local_census_connections[i].id,
                        active: !segment.sync_active,
                    }
                    this.sync_busy[conn_id + '_' + segment.id] = true;
                    this.$forceUpdate();

                    //Call the webhook to save the new sync
                    window.axios.post('/api/census/add_sync', form_data)
                        .then(response => {
                            // Check if we disabled a base segment with modeled segments
                            var message = 'Sync '+(segment.sync_active == 1 ? 'Deactivated' : 'Activated')+'!';
                            var modeledNames = [];
                            if (segment.sync_active == 1 && this.hasActiveModeledSegments(segment, conn_id)) {
                                modeledNames = this.getModeledSegmentNames(segment, conn_id);
                                message = `Base audience and ${modeledNames.length} dependent modeled audience${modeledNames.length > 1 ? 's' : ''} disabled!`;
                                
                                // Also disable modeled segments in UI across all datasets in this connection
                                for (var connIdx = 0; connIdx < this.local_connection_datasets.length; connIdx++) {
                                    var connData = this.local_connection_datasets[connIdx];
                                    if (connData.id === conn_id) {
                                        for (var datasetIdx = 0; datasetIdx < connData.datasets_to_sync.length; datasetIdx++) {
                                            var dataset = connData.datasets_to_sync[datasetIdx];
                                            for (var segIdx = 0; segIdx < dataset.segments.length; segIdx++) {
                                                var seg = dataset.segments[segIdx];
                                                if (seg.type === 'modeled' && seg.data_source_id === segment.id) {
                                                    if (seg.sync_active == 1) {
                                                        seg.sync_active = 0;
                                                        seg.last_synced = null;
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            
                            this.showNotification({
                                text: message
                            });
                            //Toggle the sync status (and the date)
                            if(segment.sync_active == 1){
                                segment.sync_active = 0;
                                segment.last_synced = null;
                            }
                            else {
                                segment.sync_active = 1;
                                segment.last_synced = new Date();
                            }
                            this.updatePushedSegmentCount(conn_id);
                            this.$forceUpdate();

                        }).catch(error => {
                            if(error.response.status == 400)
                                //Fields weren't mapped, time to redirect....
                                router.visit('/pathways/' + this.client.url + '/' + conn_id + '/mapping/' + segment.source + '/' + segment.data_source_id);
                            if(error.response.status == 500) {
                                if(error.response.data.census_error != null)
                                    this.local_census_connections[i].status_msg = error.response.data.census_error;
                                if(error.response.data.sync_error != null)
                                    this.local_census_connections[i].syncs.push({
                                        last_sync_status: error.response.data.sync_error,
                                        client_id: this.client.id,
                                        segment_id: segment.id,
                                        census_connection_id: this.local_census_connections[i].id
                                    });

                                // Show error notification
                                this.showNotification({
                                    text: 'Error syncing segment: ' + (error.response?.data?.census_error || error.response?.data?.sync_error || 'An unexpected error occurred. Please try again.'),
                                    type: 'error'
                                }); 
                            }
                            this.sync_busy[conn_id + '_' + segment.id] = false;
                            this.$forceUpdate();
                        });
                    return;
                }
            }

            //If not, redirect to the mapping page
            router.visit('/pathways/' + this.client.url + '/' + conn_id + '/mapping/' + segment.source + '/' + segment.data_source_id);
        },
        forceSync(conn, segment) {
            var conn_id = conn.id;

            //See if there is a census_connection set up
            for(var i = 0; i < this.local_census_connections.length; i++) {
                if(this.local_census_connections[i].connection_id == conn_id && segment.source ==
                    this.local_census_connections[i].source && segment.data_source_id ==
                    this.local_census_connections[i].data_source_id) {

                    var form_data = {
                        client_id: this.client.id,
                        segment_id: segment.id,
                        census_connection_id: this.local_census_connections[i].id
                    }
                    this.sync_busy[conn_id + '_' + segment.id] = true;
                    this.$forceUpdate();

                    //Call the webhook to force sync
                    window.axios.post('/api/census/force_sync', form_data)
                        .then(response => {
                            this.showNotification({
                                text: 'The sync for <strong>' + segment.name + '</strong> has started.'
                            });
                            this.$forceUpdate();
                        })
                        .catch(error => {
                            if(error.response.status == 400) {
                                //Fields weren't mapped, time to redirect....
                                router.visit('/pathways/' + this.client.url + '/' + conn_id + '/mapping/' + segment.source + '/' + segment.data_source_id);
                            }
                            if(error.response.status == 500) {
                                if(error.response.data.census_error != null)
                                    this.local_census_connections[i].status_msg = error.response.data.census_error;
                                if(error.response.data.sync_error != null)
                                    this.local_census_connections[i].syncs.push({
                                        last_sync_status: error.response.data.sync_error,
                                        client_id: this.client.id,
                                        segment_id: segment.id,
                                        census_connection_id: this.local_census_connections[i].id
                                    });
                            }
                            this.sync_busy[conn_id + '_' + segment.id] = false;
                            this.$forceUpdate();
                        });
                    return;
                }
            }

            //If not, redirect to the mapping page
            router.visit('/pathways/' + this.client.url + '/' + conn_id + '/mapping/' + segment.source + '/' + segment.data_source_id);
        },
        cancelSync(conn, segment) {
            var conn_id = conn.id;

            //See if there is a census_connection set up
            for(var i = 0; i < this.local_census_connections.length; i++) {
                if(this.local_census_connections[i].connection_id == conn_id && segment.source ==
                    this.local_census_connections[i].source && segment.data_source_id ==
                    this.local_census_connections[i].data_source_id) {

                    var form_data = {
                        client_id: this.client.id,
                        segment_id: segment.id,
                        census_connection_id: this.local_census_connections[i].id
                    }
                    this.sync_busy[conn_id + '_' + segment.id] = false;
                    this.$forceUpdate();

                    //Call the webhook to cancel sync
                    window.axios.post('/api/census/cancel_sync', form_data)
                        .then(response => {
                            this.showNotification({
                                text: 'The sync for <strong>' + segment.name + '</strong> has been cancelled.'
                            });
                            this.$forceUpdate();
                        })
                        .catch(error => {
                            if(error.response.status == 500) {
                                if(error.response.data.census_error != null)
                                    this.local_census_connections[i].status_msg = error.response.data.census_error;
                                if(error.response.data.sync_error != null)
                                    this.local_census_connections[i].syncs.push({
                                        last_sync_status: error.response.data.sync_error,
                                        client_id: this.client.id,
                                        segment_id: segment.id,
                                        census_connection_id: this.local_census_connections[i].id
                                    });
                            }
                            this.$forceUpdate();
                        });
                    return;
                }
            }

            //If not, redirect to the mapping page
            router.visit('/pathways/' + this.client.url + '/' + conn_id + '/mapping/' + segment.source + '/' + segment.data_source_id);
        },
        updatePushedSegmentCount(conn_id){
            var index = this.local_connection_datasets.findIndex(conn => conn.id = conn_id);

            var count_temp = 0;
            this.local_connection_datasets[index].datasets_to_sync.forEach(dataset =>{
                dataset.segments.forEach(segment =>{
                    if(segment.last_synced){
                        count_temp++;
                    }
                })
            })
            this.local_connection_datasets[index].pushed_segment_count = count_temp;
        },
        updateSegmentToDataSet(seg) {
            var set = this.local_datasets;

            if(seg.source == 'data_blend' || seg.source == 'datablend')
                set = this.local_datablends;

            for(var i = 0; i < set.length; i++)
                if(set[i].id == seg.data_source_id)
                    for(var j= 0; j < set[i].segments.length; j++)
                        if( set[i].segments[j].id == seg.id)
                            set[i].segments[j] = seg;

            for(var i = 0; i < this.local_connection_datasets.length; i++)
                for(var j = 0; j < this.local_connection_datasets[i].datasets_to_sync.length; j++)
                    for(var k = 0; k < this.local_connection_datasets[i].datasets_to_sync[j].segments.length; k++)
                        if(this.local_connection_datasets[i].datasets_to_sync[j].segments[k].id == seg.id){
                            let tmp_seg = {...seg};
                            tmp_seg.sync_active = this.local_connection_datasets[i].datasets_to_sync[j].segments[k].sync_active;
                            tmp_seg.sync_errors = this.local_connection_datasets[i].datasets_to_sync[j].segments[k].sync_errors;
                            this.local_connection_datasets[i].datasets_to_sync[j].segments[k] = tmp_seg;
                        }

            this.$forceUpdate();
        },
        sortByKey(key, conn_index, set_index){
            this.sort_key = key;
            this.sort_conn_index = conn_index;
            this.sort_set_index = set_index;

            if (this.sort_key != key){
                this.sort_order = 'asc'; // reset to ascending sorting order
            } else{
                this.sort_order = (this.sort_order == 'asc'? 'des':'asc');
            }
            this.sortDataWithLabel();
        },
        sortDataWithLabel(){
            let segments = this.local_connection_datasets[this.sort_conn_index].datasets_to_sync[this.sort_set_index].segments;
            if(segments.length == 0)
                return;

            //Find the right census connection ID
            let census_conn_id = 0;
            for(var i = 0; i < this.local_census_connections.length; i++)
                if(this.local_census_connections[i].connection_id == this.local_connection_datasets[this.sort_conn_index].id && segments[0].data_source_id == this.local_census_connections[i].data_source_id &&
                    this.local_census_connections[i].source == segments[0].source)
                    census_conn_id = this.local_census_connections[i].id;

            if(this.sort_key == 'sizes'){
                if(this.sort_order == 'asc')
                    segments.sort((a, b) => {
                        //Find the size that matches the census connection ID
                        let aFound = (a[this.sort_key] == null) ? false : a[this.sort_key].find(item => item.id === census_conn_id);
                        //If I didn't find one, just find the default (where ID = 0)
                        if(!aFound)
                            aFound = (a[this.sort_key] == null) ? false : a[this.sort_key].find(item => item.id === 0);
                        const aValue = aFound ? aFound.size : 0;

                        //Find the size that matches the census connection ID
                        let bFound = (b[this.sort_key] == null) ? false : b[this.sort_key].find(item => item.id === census_conn_id);
                        //If I didn't find one, just find the default (where ID = 0)
                        if(!bFound)
                            bFound = (b[this.sort_key] == null) ? false : b[this.sort_key].find(item => item.id === 0);

                        const bValue = bFound ? bFound.size : 0;

                        // Compare the size values
                        return aValue - bValue;
                    });
                else
                    segments.sort((a, b) => {
                        //Find the size that matches the census connection ID
                        let aFound = (a[this.sort_key] == null) ? false : a[this.sort_key].find(item => item.id === census_conn_id);
                        //If I didn't find one, just find the default (where ID = 0)
                        if(!aFound)
                            aFound = (a[this.sort_key] == null) ? false : a[this.sort_key].find(item => item.id === 0);
                        const aValue = aFound ? aFound.size : 0;

                        //Find the size that matches the census connection ID
                        let bFound = (b[this.sort_key] == null) ? false : b[this.sort_key].find(item => item.id === census_conn_id);
                        //If I didn't find one, just find the default (where ID = 0)
                        if(!bFound)
                            bFound = (b[this.sort_key] == null) ? false : b[this.sort_key].find(item => item.id === 0);
                        const bValue = bFound ? bFound.size : 0;

                        // Compare the size values
                        return bValue - aValue;
                    });
            }
            else if(this.sort_key == 'failed_records') {
                if(this.sort_order == 'asc')
                    segments.sort((a, b) => {
                        const aValue = this.getLastSyncRecordsFailed(this.local_connection_datasets[this.sort_conn_index].id, a.id) || 0;
                        const bValue = this.getLastSyncRecordsFailed(this.local_connection_datasets[this.sort_conn_index].id, b.id) || 0;
                        return aValue - bValue;
                    });
                else
                    segments.sort((a, b) => {
                        const aValue = this.getLastSyncRecordsFailed(this.local_connection_datasets[this.sort_conn_index].id, a.id) || 0;
                        const bValue = this.getLastSyncRecordsFailed(this.local_connection_datasets[this.sort_conn_index].id, b.id) || 0;
                        return bValue - aValue;
                    });
            }
            else if(this.sort_key == 'updated_records') {
                if(this.sort_order == 'asc')
                    segments.sort((a, b) => {
                        const aValue = this.getLastSyncRecordsUpdated(this.local_connection_datasets[this.sort_conn_index].id, a.id) || 0;
                        const bValue = this.getLastSyncRecordsUpdated(this.local_connection_datasets[this.sort_conn_index].id, b.id) || 0;
                        return aValue - bValue;
                    });
                else
                    segments.sort((a, b) => {
                        const aValue = this.getLastSyncRecordsUpdated(this.local_connection_datasets[this.sort_conn_index].id, a.id) || 0;
                        const bValue = this.getLastSyncRecordsUpdated(this.local_connection_datasets[this.sort_conn_index].id, b.id) || 0;
                        return bValue - aValue;
                    });
            }
            else if(this.sort_key == 'type'){
                // Sorting logic for the "Type" column
                if(this.sort_order == 'asc')
                    segments.sort((a, b) => {
                        const aType = a.type || 'owned';
                        const bType = b.type || 'owned';
                        return aType.localeCompare(bType);
                    });
                else
                    segments.sort((a, b) => {
                        const aType = a.type || 'owned';
                        const bType = b.type || 'owned';
                        return bType.localeCompare(aType);
                    });
            }
            else if(this.sort_order == 'asc')
                segments.sort((a, b) => (a[this.sort_key ] > b[this.sort_key ]) ? 1 : -1);
            else
                segments.sort((a, b) => (a[this.sort_key ] < b[this.sort_key ]) ? 1 : -1);
        },
        hasSyncErrors(conn) {
            // Check if any segments in this connection have sync errors
            for (const dataset of conn.datasets_to_sync) {
                for (const segment of dataset.segments) {
                    if (segment.sync_active) {
                        const lastSyncStatus = this.getLastSyncStatus(conn.id, segment.id);
                        if (lastSyncStatus === 'failed') {
                            return true;
                        }
                    }
                }
            }
            return false;
        },
        downloadRecords(conn_id, segment_id, status) {
            const run_id = this.getLastSyncRunId(conn_id, segment_id);
            if (!run_id) return;

            if(status == 'rejected'){
                this.failed_records_busy[conn_id + '_' + segment_id] = true;
            }
            else if(status == 'succeeded'){
                this.updated_records_busy[conn_id + '_' + segment_id] = true;
            }
            this.$forceUpdate();

            window.axios.get(`/api/census/records/${status}/${run_id}`)
                .then(response => {
                    // Create a link and trigger download
                    const link = document.createElement("a");
                    link.href = response.data.download_url;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                })
                .catch(error => {
                    this.showNotification({
                        text: 'Error downloading records. Please try again.',
                        type: 'error'
                    });
                })
                .finally(() => {
                    if(status == 'rejected'){
                        this.failed_records_busy[conn_id + '_' + segment_id] = false;
                    }
                    else if(status == 'succeeded'){
                        this.updated_records_busy[conn_id + '_' + segment_id] = false;
                    }
                    this.$forceUpdate();
                });
        },
        isLastSyncedOverTwoWeeks(last_synced) {
            if (!last_synced) return false;
            const last = new Date(last_synced);
            const now = new Date();
            const diff = now - last;
            return diff > 14 * 24 * 60 * 60 * 1000; // 14 days in ms
        },
        hasMatchingCensusConnection(conn_id) {
            for(var i = 0; i < this.local_census_connections.length; i++) {
                if(this.local_census_connections[i].connection_id == conn_id) {
                    return true;
                }
            }
            return false;
        },
        showSegmentTypeColumn(conn_index, set_index) {
            // Check if any segments in this dataset have different types
            const segments = this.local_connection_datasets[conn_index].datasets_to_sync[set_index].segments;
            const types = new Set();
            segments.forEach(segment => {
                types.add(segment.type || 'owned');
            });
            return types.size > 1;
        },
        getFilteredSegments(segments, conn) {
            // Filter segments based on integration's census_segment_types
            return segments.filter(segment => {
                const segmentType = segment.type || 'owned';
                
                // If integration doesn't have census_segment_types defined, allow all
                if (!conn.integration || !conn.integration.census_segment_types) {
                    return true;
                }
                
                // Check if the segment type is in the allowed types
                return conn.integration.census_segment_types.includes(segmentType);
            });
        }
    }
});
</script>
